module.exports = __webpack_public_path__ + "static/media/mission.d216f8ea.png";